const formDataSchema = {
    feilds: [{
        id: 1,
        name: 'patientname',
        title: 'Patient Name',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Patient Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 9,
        name: 'patient_type',
        title: 'Type Of Patient',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'please select Patient Types'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 5,
        name: 'claim_type',
        title: 'Claim Type',
        visible: false,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'please select Claim Type'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 11,
        name: 'type_of_insurance',
        title: 'Type Of Insurance',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'please select Type Of Insurance'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 15,
        name: 'pre_auth_status',
        title: 'Pre Auth Status',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Please select Pre Auth Status',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    // return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Pre Auth Status'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 10,
        name: 'insurance_status',
        title: 'Insurance Status',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'please select Insurance Status'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    },{
        id: 11,
        name: 'tpa_name',
        title: 'TPA *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'TPA',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'please enter TPA'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 15,
        name: 'insurance_company',
        title: 'Insurance Company *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Please select company',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select insurance company'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },  {
        id: 12,
        name: 'corporate_name',
        title: 'Employer name',
        visible: false,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Corporate Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    },
    {
        id: 15,
        name: 'type_of_management',
        title: 'Care Management *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Please select type of management',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please select type of management'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 15,
        name: 'type_of_package',
        title: 'Estimate type *',
        visible: false,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Please select type of package',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please select type of package'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    }, {
        id: 15,
        name: 'package_name',
        title: 'Package Name *',
        visible: false,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Please select package',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please select package'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    }, {
        id: 11,
        name: 'length_of_stay',
        title: 'Length Of Stay (Approx days)*',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'number',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0)
                    return true;
                },
                message: 'Please Enter Length Of Stay'
            }
        ],
        errors: [],
        value: null,
        valid: true,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 10,
        name: 'surgery_procedure_name',
        title: 'Surgery/Procedure Name *',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Surgery/Procedure Name'
            }
        ],
        errors: [],
        value: null,
        valid: true,
        state: '',
        disable: true,
        className: 'col-4'
    }, {
        id: 9,
        name: 'date_of_surgery',
        title: 'Date Of Surgery/Procedure *',
        visible: true,
        element: 'date',
        required: true,
        input_type: 'date',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Date  Of Surgery'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    },

    // {
    //         id: 6,
    //         name: 'type_of_package',
    //         title: 'Type Of Package',
    //         visible: true,
    //         element: 'select2',
    //         required: true,
    //         input_type: 'select',
    //         placeholder: 'Select',
    //         icon: 'user',
    //         rules: [
    //             {
    //                 test: (value) => {
    //                     //return (value !== null && value.length > 0);
    //                     return true;
    //                 },
    //                 message: 'please select Type Of Package'
    //             }
    //         ],
    //         errors: [],
    //         value: null,
    //         valid: false,
    //         state: '',
    //         disable: false,
    //         className: 'col-4'
    //     },{
    //         id: 7,
    //         name: 'length_of_stay',
    //         title: 'Length Of Stay',
    //         visible: true,
    //         element: 'input',
    //         required: true,
    //         input_type: 'number',
    //         placeholder: 'Enter',
    //         icon: 'user',
    //         rules: [
    //             {
    //                 test: (value) => {
    //                     //return (value !== null && value.length > 0);
    //                     return true;
    //                 },
    //                 message: 'Please Enter Length Of Stay'
    //             }
    //         ],
    //         errors: [],
    //         value: null,
    //         valid: false,
    //         state: '',
    //         disable: false,
    //         className: 'col-4'
    //     },


    // {
    //     id: 8,
    //     name: 'estimate_amount',
    //     title: 'Estimate Amount',
    //     visible: true,
    //     element: 'input',
    //     required: true,
    //     input_type: 'number',
    //     placeholder: 'Enter',
    //     icon: 'user',
    //     rules: [
    //         {
    //             test: (value) => {
    //                 //return (value !== null && value.length > 0);
    //                 return true;
    //             },
    //             message: 'Please Enter Estimate Amount'
    //         }
    //     ],
    //     errors: [],
    //     value: null,
    //     valid: false,
    //     state: '',
    //     disable: false,
    //     className: 'col-4'
    // }

]
}

const preExistFormFEild = {
    feilds:
        [{
            id: 14,
            name: 'sum_insured_four_years_back',
            title: 'sum insured onset date',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: 'Select',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'please Enter sum insured onset date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3'
        }, {
            id: 14,
            name: 'consider_si_four_years_back',
            title: 'consder si',
            visible: true,
            element: 'checkbox',
            required: true,
            input_type: 'text',
            placeholder: 'checkbox',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'please Select consder si'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3'

        }]
}
const formData2Schema = {

    feilds: [{
        id: 15,
        name: 'basic_sum_insured',
        title: 'Basic Sum Insured*',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Basic Sum Insured'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 16,
        name: 'buffer_top_up',
        title: 'Topup Amount',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Buffer/Topup Amount'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 17,
        name: 'balance_sum_insured',
        title: 'Balance Sum Insured',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Balance Sum Insured'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 18,
        type: "group",
        element: 'input2',
        visible: true,
        name: "room_eligible",
        title: 'Room Eligibility* (%) or Amount',
        data: [{
            id: 18,
            name: 'room_eligible_percent',
            title: 'Room Eligibility* (%) or Amount',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: '%',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 18,
            name: 'room_eligible_amount',
            title: 'Room Eligibility* (%) or Amount',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }],
        errors: [],
        className: 'col-4'
    }, {
        id: 20,
        type: "group",
        name: "icu_eligible",
        element: 'input2',
        visible: true,
        title: 'ICU Eligibility (%) Or Amount',
        data: [{
            id: 18,
            name: 'icu_percent',
            title: 'ICU Eligibility (%) Or Amount',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: '%',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 18,
            name: 'icu_amount',
            title: 'Room Eligibility* (%) or Amount',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }],
        errors: [],
        className: 'col-4'
    }, {
        id: 22,
        type: "group",
        name: 'co_pay',
        element: 'input2',
        visible: true,
        title: 'Co-pay (%) or Amount',
        data: [{
            id: 18,
            name: 'copay_percent',
            title: 'ICU Eligibility (%) Or Amount',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: '%',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 18,
            type: "group",
            name: 'copay_amount',
            title: 'Room Eligibility* (%) or Amount',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }],
        errors: [],
        className: 'col-4'
    }, {
        id: 3,
        name: 'room_eligibility',
        type: "group",
        title: 'Room Eligibility Ward',
        visible: true,
        element: 'select3',
        data: [{
            id: 3,
            name: 'room_eligible_ward',
            title: 'Room Eligibility Ward',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'select Room Eligibility Ward',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility Ward'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 3,
            name: 'room_eligible_ward_amount',
            title: 'Room Eligibility Ward',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility Ward'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }],
        errors: [],
        className: 'col-4'
    }, {
        id: 5,
        type: "group",
        name: 'upgrade_room',
        title: 'Upgrade Room Ward',
        visible: true,
        element: 'select3',
        data: [{
            id: 3,
            name: 'upgrade_room',
            title: 'Room Eligibility Ward',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'select Room Eligibility Ward',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility Ward'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 3,
            name: 'upgrade_room_amount',
            title: 'Room Eligibility Ward',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility Ward'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }],
        errors: [],
        className: 'col-4'
    },{
        id: 14,
        name: 'room_upgrade_reason',
        title: 'Room Upgrade Reason*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select Room Upgrade',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Room Upgrade'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 7,
        name: 'select_difference',
        title: 'Select Difference*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Enter',
        icon: 'number',
        rules: [
            {
                test: (value) => {
                    // return (value !== null && value.length > 0)
                    return true;
                },
                message: 'Please Select Difference'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 7,
        name: 'room_differance',
        title: 'Room Difference Amount*',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Enter',
        icon: 'number',
        rules: [
            {
                test: (value) => {
                    // return (value !== null && value.length > 0)
                    return true;
                },
                message: 'Please Enter Room Difference Amount'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    }, {
        id: 8,
        name: 'pro_rata_differance',
        title: 'Pro Rata Difference Amount*',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    var regex = /^\d{10}$/g;


                    if (value !== null && value.length > 0 && regex.test(value) === false) {
                        return false;
                    } else {
                        return true;
                    }
                },
                message: 'Please Enter Pro Rata Difference amount'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4'
    }, {
        id: 9,
        type: "group",
        name: 'nme',
        title: 'NME % or Amount',
        visible: true,
        element: 'input2',
        data: [{
            id: 18,
            name: 'nme_percent',
            title: 'ICU Eligibility (%) Or Amount',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: '%',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 18,
            name: 'nme_amount',
            title: 'Room Eligibility* (%) or Amount',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }],
        className: 'col-4'
    }, {
        id: 12,
        name: 'ailment_capping_status',
        title: 'Ailment Capping',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'select Ailment Capping',
        icon: 'number',
        rules: [
            {
                // test: (value) => {
                //     var regex = /^\d{10}$/g;


                //     if (value !== null && value.length > 0 && regex.test(value) === false) {
                //         return false;
                //     } else {
                //         return true;
                //     }
                // },
                message: 'Please Enter Ailment Capping'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }]
}
const formData3Schema = {
    feilds: [{
        id: 1,
        name: 'initial_approval_amount',
        title: 'Intial Approval Amount',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Submitted Amount'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3'
    }, {
        id: 2,
        name: 'package_differance',
        title: 'Package Difference',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Package Difference'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3'
    }, {
        id: 1,
        name: 'submitted_amount',
        title: 'Submitted Amount',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    // return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Submitted Amount'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3'
    },
    {
        id: 2,
        name: 'final_approval',
        title: 'Final Approval Amount',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'number',
        rules: [
            {
                test: (value) => {
                    // return (value !== null && value.length > 0)
                    return true;
                },
                message: 'Please Enter Final Approval Amount'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3'
    }, {
        id: 3,
        name: 'discount',
        title: 'Discount If Any',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    // return (value !== null && value.length > 0)
                    return true;
                },
                message: 'Please Enter Discount If Any'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3'
    }, {
        id: 4,
        name: 'extra_deduction',
        title: 'Extra Deduction Amount',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    var regex = /^\d{10}$/g;


                    if (value !== null && value.length > 0 && regex.test(value) === false) {
                        return false;
                    } else {
                        return true;
                    }
                },
                message: 'Please Enter Extra Deduction Amount'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3'
    }, {
        id: 7,
        name: 'differance_amount',
        title: 'Difference Amount',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    var regex = /^\d{10}$/g;


                    if (value !== null && value.length > 0 && regex.test(value) === false) {
                        return false;
                    } else {
                        return true;
                    }
                },
                message: 'Please Enter Difference Amount'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3'
    }, {
        id: 6,
        name: 'remarks',
        title: 'Remarks',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Enter Remarks'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-9'
    }
    ]
}

const preExistingForm = {
    feilds:
        [{
            name: 'pre_existing_group',
            data: [{
                id: 14,
                name: 'condition_name',
                title: 'condition name',
                visible: true,
                element: 'select2',
                required: true,
                input_type: 'select',
                placeholder: 'Select',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'please select condition name'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }, {
                id: 9,
                name: 'onset_data',
                title: 'onset date',
                visible: true,
                element: 'date',
                required: true,
                input_type: 'date',
                placeholder: 'Enter',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            return (value !== null && value.length > 0);
                        },
                        message: 'Please Select onset date'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }, {
                id: 14,
                name: 'sum_insured_onset_data',
                title: 'sum insured onset date',
                visible: true,
                element: 'input',
                required: true,
                input_type: 'number',
                placeholder: 'Select',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'please Enter sum insured onset date'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }, {
                id: 14,
                name: 'consder_si',
                title: 'consder si',
                visible: true,
                element: 'checkbox',
                required: true,
                input_type: 'text',
                placeholder: 'checkbox',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'please Select consder si'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }]
        }]
}



const intermForm = {
    feilds:
        [{
            name: 'interm_group',
            data: [{
                id: 1,
                name: 'interim_amount',
                title: 'Intial Approval',
                visible: true,
                element: 'input',
                required: true,
                input_type: 'number',
                placeholder: 'Enter',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'Please Enter Submitted Amount'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }, {
                id: 14,
                name: 'case_no',
                title: 'Additional Procedure',
                visible: true,
                element: 'input',
                required: true,
                input_type: 'text',
                placeholder: 'Select',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'please select Additional Procedure'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }, {
                id: 14,
                name: 'aprox_bill',
                title: 'Additional Procedure',
                visible: true,
                element: 'input',
                required: true,
                input_type: 'text',
                placeholder: 'Select',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'please select Additional Procedure'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }]
        }]
}


const ailmentFrorm = {
    feilds:
        [{
            name: 'interm_group',
            data: [{
                id: 14,
                name: 'surgery',
                title: 'Additional Procedure',
                visible: true,
                element: 'select2',
                required: true,
                input_type: 'select',
                placeholder: 'Select',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'please select Additional Procedure'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }, {
                id: 14,
                name: 'surgery_amount',
                title: 'Additional Procedure',
                visible: true,
                element: 'input',
                required: true,
                input_type: 'text',
                placeholder: 'Select',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'please select Additional Procedure'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }]
        }]
}


const additionalFrorm = {
    feilds:
        [{
            name: 'additional_group',
            data: [{
                id: 14,
                name: 'additional_procdure_id',
                title: 'Additional Procedure',
                visible: true,
                element: 'select2',
                required: true,
                input_type: 'select',
                placeholder: 'Select',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'please select Additional Procedure'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3'
            }, {
                id: 14,
                name: 'additional_procdure_amount',
                title: 'Additional Procedure',
                visible: true,
                element: 'input',
                required: true,
                input_type: 'number',
                placeholder: 'Select',
                icon: 'user',
                rules: [
                    {
                        test: (value) => {
                            //return (value !== null && value.length > 0);
                            return true;
                        },
                        message: 'please select Additional Procedure'
                    }
                ],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3'
            }]
        }]
}

const addonSchema = {
    feilds: [{
        id: 4,
        name: 'room_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3',
        service_group: 'Room Charges',
        Specification: ['Room charges include Bed charges, Nursing charges, daily patient meals (as advised by Dietician).', 'Calculated for 24 hours from time of admission with grace period of 3 hrs.', 'Additional room charges will be levied if attendant uses/continues to occupy the patient room when patient is in OT / ICU.']
    }, {
        id: 4,
        name: 'pharmacy_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'Pharmacy',
        Specification: ['All pharmacy will be billed as per MRP.',
            'Unused pharmacy items will be returned to pharmacy.',
            'Implants/Stents will be charged additionally as per usage.',
            'Drug Administration Charges will be billed for handling drugs. These charges depend on the pharmacy items used.',
            'Discharge Medication are not part of the In Patient bill. Patient attendant is suggested to buy the medications at our OP Pharmacy.']
    }, {
        id: 4,
        name: 'Professional_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'Professional Fees & DMO',
        Specification: ['Professional Fees will be charged for the treatment rendered by the following specialists:',
            'Physician / Surgeon/ Asst. Surgeon',
            'Anesthetist / Asst. Anesthetist',
            'Intensivist / Asst. Intensivist',
            'DMO Charges will be levied daily for (24 x 7) round the clock presence/care given by Duty Medical Officers in the Ward/ICU']
    }, {
        id: 4,
        name: 'cross_consultation_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'Cross Consultation',
        Specification: ['Referrals for consultation to any other specialty will be charged']
    }, {
        id: 4,
        name: 'investigations_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'Investigations',
        Specification: ['Estimate includes all routine investigations commonly recommended / prescribed for the relevant treatment.',
            'Viral screening mandatory for surgical intervention planned/ proposed for patient treatment.',
            'Any specialized investigations prescribed based on co-morbid condition like diabetes / thyroid/HTN/etc will be charged to the patient in addition to the above estimate to the patient.']
    }, {
        id: 4,
        name: 'procedures_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'Procedures',
        Specification: ['Estimate includes the price of undergoing the prescribed procedures only.',
            'Charges applicable for any specialized / related procedure(s) to aide further medical recover will be notified separately and accordingly billed to the patient as and when carried out']
    }, {
        id: 4,
        name: 'ot_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'OT Charges ',
        Specification: ['OT charges are billed on hourly basis for utilization of the Operation Theatre.']
    }, {
        id: 4,
        name: 'general_equipment_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'General Equipment',
        Specification: ['Equipment used in Wards/ICUs is billed depending on the duration of usage. of usage.',
            'Eg Ventilators, Infusion pumps, Nebulization, Oxygen, Monitors, Bi-pap, C-pap, Alpha bed etc']
    }, {
        id: 4,
        name: 'ot_equipment_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'OT Equipment/ Instruments',
        Specification: ['Equipment and Instruments used in Operation Theatre',
            'Eg Lap Set, Microscope, C-Arm, Drills, Camera, Scalpels, Laser, Ligasure,Robot etc']
    }, {
        id: 4,
        name: 'f_b_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'F & B and  Dietician',
        Specification: ['Patient’s diet advised by the dietician is included in the room charges.',
            'All attendant orders and additional patient orders will be billed additionally to the patient.',
            'Dietician Charges are levied for all consultations by dietician']
    }, {
        id: 4,
        name: 'Physiotherapy_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'Physiotherapy',
        Specification: ['Physiotherapy charges will be billed for each session conducted by the Physiotherapist.']
    }, {
        id: 4,
        name: 'mlc_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: ' Medical record & MLC',
        Specification: ['Medical record management fee is charged for maintaining & storing patient medical records',
            'MLC charges are levied as and when applicable for medico legal cases that admit in the hospital.']
    }, {
        id: 4,
        name: 'blood_blank_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'Blood Bank',
        Specification: ['Blood and blood products utilized will be billed to the patient as per actual issues from the blood bank.',
            'All blood products used for the patient shall be replaced by voluntary donation by family/friends of the patient.',
            'Blood Transfusion Charges are billed for each unit of blood issued to the patient.',
            'Reservation charges and cross matching charges are billed for each unit of blood/blood products reserved.',
            'Blood issued to the patient from the blood bank but not returned within 15 minutes of issue (if not transferred) will be charged to the patient.']
    }, {
        id: 4,
        name: 'hospital_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'Hospital Services',
        Specification: ['Hospital charges as applicable will be charged additional based on the medical condition of the patient for serology positive patients.',
            'Diabetic/HT Management charges will be charged additionally in case patient is Diabetic/Hypertensive']
    }, {
        id: 4,
        name: 'ambulance_charges',
        title: 'token Number',
        visible: true,
        icon: 'number',
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Token Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3',
        service_group: 'ICU Charges',
        Specification: ['ICU charges includes Intensivist charges, Assistant Intensivist charges & monitor charges.']
    }]
}

export { additionalFrorm,addonSchema, formDataSchema, formData2Schema, formData3Schema, preExistingForm, intermForm, ailmentFrorm, preExistFormFEild };